export const iconFontAwesomeHumanitarianPeoplePulling = (
	<i className="fa-solid fa-people-pulling"></i>
);
